import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ControlValueAccessorConnector } from '../utils/control-value-accessor-connector/control-value-accessor-connector';
import { SelectOption } from './select-option';

@Component({
  selector: 'stena-select',
  imports: [CommonModule, MatSelectModule, ReactiveFormsModule],
  templateUrl: './stena-select.component.html',
  styleUrls: ['./stena-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StenaSelectComponent),
      multi: true,
    },
  ],
})
export class StenaSelectComponent extends ControlValueAccessorConnector {
  @Input() options: SelectOption<any>[] = [];
  @Input() label?: string;

  trackByOptions(i: number, option: SelectOption) {
    return option.value;
  }
}
